// extracted by mini-css-extract-plugin
export default {"card":"BoxItem_card__lmUJY","cardBody":"BoxItem_cardBody__Ns3Fk","labelRow":"BoxItem_labelRow__N1vfd","labelText":"BoxItem_labelText__pqGWF"};